import { defineMessages } from 'react-intl';

export default defineMessages({
  dateFilter: {
    id: 'features.wallet.performanceSection.dateFilter',
    defaultMessage: 'Orizzonte temporale',
    description: 'Label for icon to open date filter',
  },

  toggleFilter: {
    id: 'features.walletPage.performanceSection.toggleFilter',
    defaultMessage: 'Posizioni chiuse',
    description: 'Label for toggle to show/hide closed positions',
  },

  /** items select performance section */
  managedInsuranceFinancialItem: {
    id: 'features.wallet.performanceSection.managedInsuranceFinancialItem',
    defaultMessage: 'Gestito Assicurativo Finanziario',
    description: 'managed Insurance Financial Item ',
  },
  administeredItem: {
    id: 'features.wallet.performanceSection.administeredItem',
    defaultMessage: 'Amministrato',
    description: 'administrated Item ',
  },

  realEconomyItem: {
    id: 'features.wallet.performanceSection.realEconomyItem',
    defaultMessage: 'Economia Reale',
    description: 'real Economy Item ',
  },

  retirementItem: {
    id: 'features.wallet.performanceSection.retirementItem',
    defaultMessage: 'Previdenza',
    description: 'retirement Item ',
  },
  notAvialableLabel: {
    id: 'features.wallet.performanceSection.notAvialableLabel',
    defaultMessage: 'N/D',
    description: 'notAvialableLabel'
  },
  bottomDisclaimer: {
    id: 'features.wallet.performanceSection.bottomDisclaimer',
    defaultMessage:
      '* Il fondo è stato oggetto di fusione da parte della SGR. Viene mostrato il comparto presente in portafoglio alla data selezionata.',
    description: 'bottom disclaimer',
  },
  disclaimer: {
    id: 'features.wallet.performanceSection.disclaimer',
    defaultMessage:
      '** I valori riportati nella colonna “importo” rappresentano il controvalore dei movimenti regolati utilizzato ai fini della performance e potrebbero differire rispetto ai valori riportati nella colonna “controvalore” del tab “elenco posizioni”, in cui sono riportati i saldi alla data di oggi dei prodotti',
    description: 'bottom disclaimer',
  },
  disclaimerFia: {
    id: 'features.wallet.performanceSection.disclaimerFia',
    defaultMessage:
      '*** I FIA Multirichiamo sono rappresentati all’importo versato fino al completamento del periodo di investimento.',
    description: 'disclaimerFia'
  },
  footerTotalLabel: {
    id: 'features.wallet.performanceSection.footerTotalLabel',
    defaultMessage: 'Totale posizioni',
    description:
      'Label for the total amount in the footer of the macrocategory sections',
  },

  /** column name performance section */

  productDescriptionColumn: {
    id: 'features.wallet.performanceSection.productDescriptionColumn',
    defaultMessage: 'Descrizione prodotto',
    description: 'product Description Column',
  },

  productTypeColumn: {
    id: 'features.wallet.performanceSection.productTypeColumn',
    defaultMessage: 'Tipo prodotto',
    description: 'product Type Column',
  },

  productColumn: {
    id: 'features.wallet.performanceSection.productColumn',
    defaultMessage: 'Prodotto',
    description: 'Label for the Product column',
  },

  contractColumn: {
    id: 'features.wallet.performanceSection.contractColumn',
    defaultMessage: 'Contratto',
    description: 'contract Column',
  },

  investedColumn: {
    id: 'features.wallet.performanceSection.investedColumn',
    defaultMessage: 'Investito',
    description: 'invested Column',
  },

  switchInColumn: {
    id: 'features.wallet.performanceSection.switchInColumn',
    defaultMessage: 'Switch in',
    description: 'switch in Column',
  },

  retrievedColumn: {
    id: 'features.wallet.performanceSection.retrievedColumn',
    defaultMessage: 'Prelevato',
    description: 'retrieved Column',
  },

  dividendsColumn: {
    id: 'features.wallet.performanceSection.dividendsColumn',
    defaultMessage: 'Dividendi',
    description: 'dividends Column',
  },

  retrievedAndDividendsColumn: {
    id: 'features.wallet.performanceSection.retrievedAndDividendsColumn',
    defaultMessage: 'Prelevato e dividendi',
    description: 'retrieved and dividends Column',
  },

  switchOutColumn: {
    id: 'features.wallet.performanceSection.switchOutColumn',
    defaultMessage: 'Switch out',
    description: 'switch out Column',
  },

  averageStockColumn: {
    id: 'features.wallet.performanceSection.averageStockColumn',
    defaultMessage: 'Giacenza media',
    description: 'average StockColumn',
  },

  amountColumn: {
    id: 'features.wallet.performanceSection.amountColumn',
    defaultMessage: 'Importo **',
    description: 'amount Column',
  },

  plusMinusColumn: {
    id: 'features.wallet.performanceSection.plusMinusColumn',
    defaultMessage: 'Plus/Minus',
    description: 'plus/minus Column',
  },

  yieldColumn: {
    id: 'features.wallet.performanceSection.yieldColumn',
    defaultMessage: 'Rendimento',
    description: 'yield Column',
  },

  /** date picker message */
  beginningOfTheYearLabel: {
    id: 'features.wallet.performanceSection.beginningOfTheYearLabel',
    defaultMessage: 'Da inizio anno',
    description: 'beginning of the year label',
  },

  lastTwelveMonthsLabel: {
    id: 'features.wallet.performanceSection.lastTwelveMonthsLabel',
    defaultMessage: 'Ultimi 12 mesi',
    description: 'last twelve months label',
  },

  openLabel: {
    id: 'features.wallet.performanceSection.openLabel',
    defaultMessage: 'Da apertura',
    description: 'open label',
  },

  intervalLabel: {
    id: 'features.wallet.performanceSection.intervalLabel',
    defaultMessage: 'Specifica intervallo',
    description: 'interval label',
  },

  showClosedPositionsLabel: {
    id: 'features.wallet.performanceSection.showClosedPositionsLabel',
    defaultMessage: 'Posizioni Chiuse',
    description: 'Posizioni Chiuse',
  },

  /** NO PRODUCT */
  noProducts: {
    id: 'features.wallet.performanceSection.noProducts',
    defaultMessage: 'Non sono presenti prodotti che soddisfano i criteri di ricerca',
    description: 'no products message',
  }
});
